import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useSession } from './SessionProvider'
import { LoadingScreen, Alert } from '../ui'
import type { Role } from '@shared/schema/api'

/** ป้องกันหน้าที่ต้องล็อกอิน/ต้องมีบทบาทเฉพาะ */
export function RequireRole({ roles, children }: { roles?: Role[]; children: ReactNode }) {
  const { state } = useSession()
  const location = useLocation()

  if (state.status === 'loading') return <LoadingScreen />
  if (state.status === 'setupRequired') return <Navigate to="/setup" replace />
  if (state.status === 'anonymous') {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />
  }

  if (roles && !roles.includes(state.user.role)) {
    return (
      <div className="mx-auto max-w-md p-6">
        <Alert variant="error">
          บัญชีนี้ไม่มีสิทธิ์เข้าหน้านี้ — หากคิดว่าผิดพลาด กรุณาติดต่อผู้ดูแลระบบ
        </Alert>
      </div>
    )
  }

  return <>{children}</>
}
